import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BoardService } from './board.service';
import { FeatureToggleService } from '@app/feature-toggles/feature-toggle.service';

/**
 * TVG-117: shared state for the sidebar "new quotes" badge. Hides the badge
 * fully when the crm-sales-flow feature toggle is off; otherwise polls the
 * count once on init and exposes a clear() the board view can call after
 * mark-viewed has succeeded.
 */
@Injectable({ providedIn: 'root' })
export class NewQuotesBadgeService {
  private readonly state = new BehaviorSubject<number>(0);
  readonly count$: Observable<number> = this.state.asObservable();

  constructor(
    private boardService: BoardService,
    private featureToggleService: FeatureToggleService,
  ) {}

  refresh(): void {
    if (!this.featureToggleService.isEnabled('crm-sales-flow')) {
      this.state.next(0);
      return;
    }
    this.boardService.getNewQuotesCount().subscribe({
      next: (count) => this.state.next(count),
      error: () => this.state.next(0),
    });
  }

  clear(): void {
    this.state.next(0);
  }
}
